import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

export interface TypeSelectedDetail {
  type: 'claude' | 'shell';
}

@customElement('cp-cloud-terminal-type-picker')
export class CpCloudTerminalTypePicker extends LitElement {
  createRenderRoot() { return this; }

  private _select(type: 'claude' | 'shell'): void {
    this.dispatchEvent(new CustomEvent<TypeSelectedDetail>('type-selected', {
      detail: { type },
      bubbles: true, composed: true,
    }));
  }

  render() {
    return html`
      <div class="cp-cloud-terminal-type-picker">
        <div class="cp-cloud-terminal-type-picker__header">Session-Typ waehlen</div>
        <div class="cp-cloud-terminal-type-picker__list">
          <button
            class="cp-cloud-terminal-type-picker__item"
            @click=${() => this._select('claude')}
          >
            <span class="cp-cloud-terminal-type-picker__icon">&#9672;</span>
            <span class="cp-cloud-terminal-type-picker__label">Claude Code</span>
          </button>
          <div class="cp-cloud-terminal-type-picker__divider"></div>
          <button
            class="cp-cloud-terminal-type-picker__item"
            @click=${() => this._select('shell')}
          >
            <span class="cp-cloud-terminal-type-picker__icon">&#9638;</span>
            <span class="cp-cloud-terminal-type-picker__label">Shell Terminal</span>
          </button>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-cloud-terminal-type-picker': CpCloudTerminalTypePicker;
  }
}
